import BossModel from "@/models/BossModel";

export default class ChargeType extends BossModel {

    static apiUrl = 'charge-type';

    static entity = 'chargeTypes';

    static fields() {
        return {
            id: this.number(null).nullable(),
            name: this.attr(null),
            is_active: this.boolean(true),
        }
    }
}
